export const FETCH_LIST_CATEGORY_PARENT_SUCCESS = "FETCH_LIST_CATEGORY_PARENT_SUCCESS";
